import React, {useEffect, useState} from 'react';
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import {CloseOutlined} from '@mui/icons-material';
import {ButtonContained} from 'shared/components/Button';
import {COLORS} from 'shared/constants/AppEnums';
import {grey} from '@mui/material/colors';
import {useDispatch} from 'react-redux';
import {useSelector} from 'react-redux';
import {onGetTitleOptions} from 'redux/actions/admintools/Title';
import { GET_FILTER_AKSI_PERUBAHAN, RESET_AKSI_PERUBAHAN, RESET_FILTER_AKSI_PERUBAHAN } from 'shared/constants/ActionTypes';

function DialogFilter({open, onClose}) {
  const dispatch = useDispatch();
  const {filter} = useSelector((state) => state.aksiPerubahan);
  const {optionsTitle} = useSelector((state) => state.jabatan);
  const [year, setYear] = useState([]);
  const [optionYear, setOptionYear] = useState(null);
  const [optionPelatihan, setOptionPelatihan] = useState([
    {
      id: 1,
      name: 'LATIHAN DASAR',
    },
    {
      id: 2,
      name: 'PELATIHAN KEPEMIMPINAN PENGAWAS',
    },
    {
      id: 3,
      name: 'PELATIHAN KEPEMIMPINAN ADMINISTRATOR',
    },
    {
      id: 4,
      name: 'PELATIHAN KEPEMIMPINAN NASIONAL TINGKAT I',
    },
    {
      id: 5,
      name: 'PELATIHAN KEPEMIMPINAN NASIONAL TINGKAT II',
    },
  ]);
  const [pelatihan, setPelatihan] = useState([]);
  const [batch, setBatch] = useState([]);
  const [batchOption, setBatchOption] = useState([]);

  useEffect(() => {
    if (open) dispatch(onGetTitleOptions());
  }, [open]);

  useEffect(() => {
    if (pelatihan.length > 0) {
      let tmp = [];

      year.forEach((yearElement) => {
        pelatihan.forEach((element) => {
          let tmpBatch = optionsTitle.results
            .filter((x) => x.year === yearElement && x.name.includes(element))
            .map((x) => {
              return x.batch;
            });
          tmpBatch.forEach((element) => {
            tmp.push(element);
          });
        });
      });

      const uniqueArray = [...new Set(tmp)];

      setBatchOption(uniqueArray);
    }
  }, [pelatihan]);

  useEffect(() => {
    if (optionsTitle) {
      let tmp = optionsTitle.results.map((x) => {
        return x.year;
      });
      const uniqueArray = [...new Set(tmp)];

      setOptionYear(uniqueArray);
    }
  }, [optionsTitle]);

  useEffect(() => {
    console.log(batchOption);
  }, [batchOption]);

  const handleFilter = () => {
    let title = [];
  
      batch.forEach((elementBatch) => {
        year.forEach((element) => {
          let tmp = [];
          if (pelatihan.length > 1)
            tmp = optionsTitle.results.filter(
              (x) =>
                x.year === element &&
                x.batch === elementBatch &&
                (x.name.includes(pelatihan[0]) ||
                  x.name.includes(pelatihan[1])),
            );
          else if ( pelatihan.length === 1)
            tmp = optionsTitle.results.filter(
              (x) =>
                x.year === element &&
                x.batch === elementBatch &&
                x.name.includes(pelatihan[0]),
            );
          tmp.forEach(element => {
                title.push(element.id)
          });
        });
      });
    
    dispatch({type:GET_FILTER_AKSI_PERUBAHAN,payload:{
        year:year,batch:batch,title:title
    }})

    onClose()
  };

  const handleChangePelatihan = (event) => {
    setPelatihan(event.target.value);
  };

  const handleChangeYear = (event) => {
    setYear(event.target.value);
  };

  const handleChangeBatch = (event) => {
    setBatch(event.target.value);
  };

  const handleClearFilter = () => { 

    setBatch([])
    setBatchOption([])
    setYear([])
    setPelatihan([])
    dispatch({type:RESET_FILTER_AKSI_PERUBAHAN})
   }

  return (
    <Dialog
      open={open}
      sx={{
        '& .MuiDialog-paper': {
          maxWidth: '800px !important',
          width: '750px',
          height: '500px',
          borderRadius: '16px',
        },
      }}
      onClose={onClose}
    >
      <DialogTitle sx={{display: 'flex', justifyContent: 'space-between'}}>
        <Typography sx={{fontWeight: '600', fontSize: '18px'}}>
          Filter Aksi Perubahan
        </Typography>
        <CloseOutlined onClick={onClose} />
      </DialogTitle>{' '}
      <Divider sx={{marginY: 2}} />
      <DialogContent>
        <form>
          <Box
            padding={'10px'}
            maxHeight={'335px'}
            overflow={'auto'}
            sx={{
              '& label.Mui-focused': {
                color: COLORS.primary,
              },
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': {
                  borderColor: grey[500],
                },
                '&.Mui-focused fieldset': {
                  borderColor: COLORS.primary,
                  color: COLORS.primary,
                },
              },
            }}
          >
            <Grid container columnSpacing={4} rowSpacing={3}>
              <Grid item xs={12} md={12}>
                <FormControl fullWidth>
                  <InputLabel id='demo-simple-select-label'>
                     Tahun
                  </InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='tahun'
                    name='tahun'
                    label='Tahun'
                    value={year}
                    multiple
                    onChange={handleChangeYear}
                    renderValue={(selected) => selected.join(', ')}
                  >
                    {optionYear
                      ? optionYear.map((item, key) => {
                          return (
                            <MenuItem key={item} value={item}>
                              <Checkbox checked={year.indexOf(item) > -1} />
                              <ListItemText primary={item} />
                            </MenuItem>
                          );
                        })
                      : ''}
                  </Select>
                </FormControl>
              </Grid>
              {year.length > 0 && (
                <Grid item xs={12} md={12}>
                  <FormControl fullWidth>
                    <InputLabel id='demo-simple-select-label'>
                       Jenis Kategori
                    </InputLabel>
                    <Select
                      labelId='demo-simple-select-label'
                      id='jenis'
                      name='jenis'
                      multiple
                      label='Jenis Kategori'
                      value={pelatihan}
                      onChange={handleChangePelatihan}
                      renderValue={(selected) => selected.join(', ')}
                    >
                      {optionPelatihan
                        ? optionPelatihan.map((item, key) => {
                            return (
                              <MenuItem key={item.id} value={item.name}>
                                <Checkbox
                                  checked={pelatihan.indexOf(item.name) > -1}
                                />
                                <ListItemText primary={item.name} />
                              </MenuItem>
                            );
                          })
                        : ''}
                    </Select>
                  </FormControl>
                </Grid>
              )}
              {pelatihan.length > 0 && (
                <Grid item xs={12} md={12}>
                  <FormControl fullWidth>
                    <InputLabel id='demo-simple-select-label'>
                       Angkatan
                    </InputLabel>
                    <Select
                      labelId='demo-simple-select-label'
                      id='angkatan'
                      name='angkatan'
                      label='Angkatan'
                      multiple
                      value={batch}
                      renderValue={(selected) => selected.join(', ')}
                      onChange={handleChangeBatch}
                    >
                      {batchOption.length > 0
                        ? batchOption.map((item, key) => {
                            return (
                              <MenuItem key={item.id} value={item}>
                                <Checkbox checked={batch.indexOf(item) > -1} />
                                <ListItemText primary={item} />
                              </MenuItem>
                            );
                          })
                        : ''}
                    </Select>
                  </FormControl>
                </Grid>
              )}
            </Grid>
          </Box>
        </form>{' '}
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          onClick={onClose}
          size='small'
          style={{
            width: '100px',
            backgroundColor: '#F5F5F5',
            color: '#9F9F9F',
          }}
        >
          BATAL
        </Button>
        <ButtonContained variant='contained' onClick={handleClearFilter}>
          CLEAR
        </ButtonContained>
        <ButtonContained variant='contained' disabled={batch.length ===0 || year.length === 0 || pelatihan.length === 0} onClick={handleFilter}>
          TAMPILKAN
        </ButtonContained>
      </DialogActions>
    </Dialog>
  );
}
DialogFilter.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default DialogFilter;
